import { Box, Typography } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { pxToRem } from '../../../commonUtils/resizeUtils';

export const TextbookQuestionTag = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: pxToRem(8),
        px: pxToRem(12),
        py: pxToRem(6),
        backgroundColor: '#E7F1FF',
        border: '1px solid #B6D4FE',
        borderRadius: pxToRem(20),
        width: 'fit-content',
      }}
    >
      <MenuBookIcon
        sx={{
          fontSize: pxToRem(16),
          color: '#0D6EFD',
        }}
      />
      <Typography
        sx={{
          fontSize: pxToRem(12),
          fontWeight: 600,
          color: '#084298',
        }}
      >
        Textbook Question
      </Typography>
    </Box>
  );
};
